import apiServices from './apiServices';

const MAX_CATEGORIES = 100;

class CategoryServices {
    async getCategories(statusIn?: string) {
        const fields = ['title', 'parentCategoryId', 'status'];
        const filters = {
            status_in: statusIn ?? 'CREATED|UPDATED|PUBLISHED',
        };
        const pagination = {
            page: 1,
            rowsPerPage: MAX_CATEGORIES,
            sortBy: 'title',
            descending: false,
        };
        const response: any = await apiServices.getAll(
            'pageCategories',
            filters,
            fields,
            pagination,
        );

        if (!response?.entries) return [];

        const entries = response.entries;

        // Build a map for O(n) tree construction
        const nodeMap = new Map<string, any>();
        entries.forEach((e: any) => {
            nodeMap.set(e.id, {
                id: e.id,
                label: e.title,
                status: e.status,
                children: [],
            });
        });

        const roots: any[] = [];
        entries.forEach((e: any) => {
            const node = nodeMap.get(e.id)!;
            if (!e.parentCategoryId || e.parentCategoryId === '') {
                roots.push(node);
            } else {
                const parent = nodeMap.get(e.parentCategoryId);
                if (parent) {
                    node.parentCategoryId = e.parentCategoryId;
                    parent.children.push(node);
                }
                // Parent missing or filtered out — node excluded from tree
            }
        });

        return roots;
    }
}
export default new CategoryServices();
